module.exports = __webpack_public_path__ + "static/media/verogo.41102ff1.png";